import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-872120fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["innerHTML"]

import { PropType, ref, computed } from 'vue';
import { find, keys, map, zipObject } from 'lodash';
import { storeToRefs } from 'pinia'
import { tr } from 'plugins/i18n';
import useRouter from 'plugins/router';
import { createFormModel, FORM_RULES, FORM_STATUS, KoddeinField, KoddeinForm } from 'components/UiKit/KoddeinVueForm';
import { store as storeUser } from 'pages/User/store';
import { store as i18nStore } from 'plugins/i18n/store';
import { store as trackingStore } from 'plugins/store/tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscription',
  props: {
  id: {
    type: Number,
    required: true,
  },
  active: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String as PropType<'mission' | 'event'>,
    default: 'mission'
  },
  color: {
    type: String as PropType<'green' | 'orange'>,
    default: 'green'
  },
  cta: {
    type: Object as PropType<Link>,
    default: undefined,
  },
  need_subscription: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const formRef = ref<any>(undefined)
const formMotivation = ref<any>(undefined)
const lightboxIncomplete = ref<any>()
const lightboxInfo = ref<any>()
const lightboxSuccess = ref<any>()

const { isConnected, projects, completion_steps } = storeToRefs(storeUser)

const isBookmarked = computed(() => {
  if (!projects.value) return false;
  const list = projects.value[props.type === 'mission' ? 'missions' : 'events']
  if(!list || list.length == 0) return false
  return !!find(list, ['id', props.id]);
})

const motivation = tr('SUBSCRIPTION.info.motivation') || {};
const model = ref(createFormModel({
  description: {
    type: 'textarea',
    validations: [FORM_RULES.REQUIRED],
    ...motivation,
  },
}));
const formState = ref<FormStatusType>(FORM_STATUS.PRISTINE);


//{ name: `volunteerdashboardAccount.${i18nLocale.name}` }

const triggerIncomplete = () => {
  lightboxIncomplete.value.open();
}
const triggerInfo = () => {
  lightboxInfo.value.open();
}

const checkUserCompletion = () => {
  // if user not completed 3 steps, stop everrything
  if(!completion_steps?.value || (completion_steps?.value && completion_steps?.value.length < 3)) {
    return triggerIncomplete();
  }

  // start modal 
  return triggerInfo();
}

const addBookmark = () => {
  storeUser.addBookmark(props.id, formRef.value.executeRecaptcha(), undefined)
  
  trackingStore.EVENT('subscribe', {
    type: props.type,
    entry: props.id,
    email: storeUser.email
  })
}

const saveMotivation = async () => {
  const token = formMotivation.value.executeRecaptcha();
  const datas = zipObject(keys(model.value), map(model.value, ({ value }) => value));
  return storeUser.addBookmark(props.id, token, datas).then(() => {
    lightboxInfo.value.close();
    lightboxSuccess.value.open();

    trackingStore.EVENT('subscribe', {
      type: props.type,
      entry: props.id,
      email: storeUser.email
    })
  });
}


return (_ctx: any,_cache: any) => {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_lightbox = _resolveComponent("ui-lightbox")!
  const _component_ui_animation = _resolveComponent("ui-animation")!

  return (_openBlock(), _createBlock(_component_ui_animation, {
    tag: "div",
    class: "subscription",
    "data-color": props.color,
    "data-type": props.type,
    "data-subscription": props.need_subscription
  }, {
    default: _withCtx(() => [
      (props.need_subscription && props.active)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ui_button, {
              theme: "primary",
              label: _ctx.$t('SUBSCRIPTION.cta_subscribe'),
              color: props.color,
              arrow: true,
              disabled: !_unref(isConnected) || isBookmarked.value,
              class: "add",
              onClick: checkUserCompletion
            }, null, 8, ["label", "color", "disabled"]),
            (!isBookmarked.value && props.active)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "info",
                  textContent: _toDisplayString(_ctx.$t(`SUBSCRIPTION.${props.type}.info_subscribe`))
                }, null, 8, _hoisted_1))
              : (props.active)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "info",
                    textContent: _toDisplayString(_ctx.$t(`SUBSCRIPTION.${props.type}.info_subscribe_active`))
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              (props.cta)
                ? (_openBlock(), _createBlock(_component_ui_button, _mergeProps({
                    key: 0,
                    theme: "primary",
                    target: "_blank"
                  }, props.cta, {
                    label: props.cta?.label || _ctx.$t('SUBSCRIPTION.cta_more'),
                    color: props.color,
                    arrow: true
                  }), null, 16, ["label", "color"]))
                : _createCommentVNode("", true),
              (!isBookmarked.value && props.active)
                ? (_openBlock(), _createBlock(_component_ui_button, {
                    key: 1,
                    theme: "link",
                    label: _ctx.$t('SUBSCRIPTION.cta_add'),
                    color: props.color,
                    disabled: !_unref(isConnected),
                    class: "add",
                    onClick: addBookmark
                  }, null, 8, ["label", "color", "disabled"]))
                : _createCommentVNode("", true)
            ]),
            (!isBookmarked.value && props.active)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "info",
                  textContent: _toDisplayString(_ctx.$t(`SUBSCRIPTION.${props.type}.info_external`))
                }, null, 8, _hoisted_4))
              : (props.active)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "info",
                    textContent: _toDisplayString(_ctx.$t(`SUBSCRIPTION.${props.type}.info_external_active`))
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
          ], 64)),
      _createVNode(_unref(KoddeinForm), {
        ref_key: "formRef",
        ref: formRef,
        class: "form",
        recaptcha: true,
        action: " "
      }, null, 512),
      _createVNode(_component_ui_lightbox, {
        ref_key: "lightboxIncomplete",
        ref: lightboxIncomplete,
        theme: "standard",
        confirm: true,
        label: _ctx.$t('SUBSCRIPTION.incomplete.cta'),
        onAccept: _cache[0] || (_cache[0] = ($event: any) => (_unref(useRouter)().push({ name: `volunteerdashboardAccount.${_unref(i18nStore).localeName}` })))
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            class: "title",
            textContent: _toDisplayString(_ctx.$t('SUBSCRIPTION.incomplete.title'))
          }, null, 8, _hoisted_6),
          _createElementVNode("div", {
            class: "description wysiwyg",
            innerHTML: _ctx.$t('SUBSCRIPTION.incomplete.description')
          }, null, 8, _hoisted_7)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_ui_lightbox, {
        ref_key: "lightboxInfo",
        ref: lightboxInfo,
        theme: "standard",
        confirm: true,
        label: _ctx.$t('SUBSCRIPTION.info.cta'),
        onAccept: saveMotivation
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            class: "title",
            textContent: _toDisplayString(_ctx.$t('SUBSCRIPTION.info.title'))
          }, null, 8, _hoisted_8),
          _createElementVNode("div", {
            class: "description wysiwyg",
            innerHTML: _ctx.$t('SUBSCRIPTION.info.description')
          }, null, 8, _hoisted_9),
          (model.value)
            ? (_openBlock(), _createBlock(_unref(KoddeinForm), {
                key: "motivation",
                ref_key: "formMotivation",
                ref: formMotivation,
                class: "motivation",
                model: model.value,
                reset: true,
                flash: false,
                "on-send": saveMotivation,
                onUpdate: _cache[3] || (_cache[3] = (data) => model.value = data),
                onStatus: _cache[4] || (_cache[4] = (status) => formState.value = status)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(KoddeinField), _mergeProps({
                    modelValue: model.value.description.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.description.value) = $event))
                  }, model.value.description, {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (model.value.description.error = ''))
                  }), null, 16, ["modelValue"])
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_ui_lightbox, {
        ref_key: "lightboxSuccess",
        ref: lightboxSuccess,
        theme: "standard",
        confirm: true,
        "accept-only": true,
        label: _ctx.$t('SUBSCRIPTION.success.cta')
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            class: "title",
            textContent: _toDisplayString(_ctx.$t('SUBSCRIPTION.success.title'))
          }, null, 8, _hoisted_10),
          _createElementVNode("div", {
            class: "description wysiwyg",
            innerHTML: _ctx.$t('SUBSCRIPTION.success.description')
          }, null, 8, _hoisted_11)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["data-color", "data-type", "data-subscription"]))
}
}

})